module.exports = __webpack_public_path__ + "img/What a Pharmacist Should Know About Pediatric Pharmacy.839c6bf7.jpg";